import React from "react";
//#region types
import { MoreActionMenuItem, MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { VoucherMoreActionProps } from "models/propTypes/voucherPropsTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";

//#endregion
//#region components
import { MoreActions } from "components/common";
import { useVoucherService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const VoucherMoreActions: React.FC<VoucherMoreActionProps> = (props) => {
  const voucherService = useVoucherService();
  const onDownloadClick = async () => {
    return voucherService.downloadVoucher(props.voucher.id ?? "");
  };

  const downloadAction = (): MoreActionMenuItem => ({
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DownloadAttachments),
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: onDownloadClick,
  });

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    if (!!props.voucher.attachments?.numberOfAttachments && !!props.voucher.attachments?.attachmentsMeta?.length)
      actions.push(downloadAction());
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} />;
};

export default VoucherMoreActions;
